import axios from 'axios'
import {Message, MessageBox} from 'element-ui'
import { showLoading, hideLoading } from './loading';
// 创建axios实例
const service = axios.create({
  withCredentials: true,
     // baseURL:"http://localhost:8080/shop/api"
  // baseURL: process.env.BASE_API, // api 的 base_url
  // baseURL: "http://dingdan.nuprobe.com.cn/shop/api/"//process.env.BASE_API, // api 的 base_url
  //  baseURL:"http://service-dev.nuprobe.com.cn/shop/api"
  baseURL:"http://service.nuprobe.com.cn/shop/api"
  // timeout: 5000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(
  config => {
    //showLoading()
    config.headers['Accept'] = "application/json";
    config.headers['Content-Type'] = "application/json";
    config.headers['Access-Control-Allow-Origin'] = "*";//("Access-Control-Allow-Origin","*");
    config.headers['Access-Control-Allow-Credentials']= true;
    if (config.url.indexOf('code')!=-1) {
      config.headers['Content-Type'] = "application/x-www-form-urlencoded";
      if(localStorage.getItem("jession")){
        config.headers.Authorization = localStorage.getItem("jession");
      }
    }
    return config
  },
  error => {
    // Do something with request error
    console.log("***********")
    console.log(error) // for debug
    Promise.reject(error)
  }
)

// response 拦截器
service.interceptors.response.use(
  response => {
    hideLoading()
    /**
     * code为非0是抛错
     */
    const res = response.data
    // if(res.code == 9){
    //   return response;
    // }
    // if(res.code == 6){
    //   return response;
    // }
    if (res.code !== 0) {
      // Message({
      //   message: res.message,
      //   type: 'error',
      //   duration: 5 * 1000
      // })
      return response
    } else {
      return response
    }
  },
  error => {
    hideLoading()
    console.log('err' + error) // for debug
    // Message({
    //   message: error.message,
    //   type: 'error',
    //   duration: 5 * 1000
    // })
    return Promise.reject(error)
  }
)

export default service




// WEBPACK FOOTER //
// ./src/utils/request.js